import angular = require('angular');
import { IPopupSettings } from '../../models';
import { PopupServiceCancel } from '../../models/popupServiceCancel';

class AlertPopupModalInstance {
    static $inject = ['$sce'];

    title: string;
    body: string;
    okTxt: string;
    okClass: string;
    closeButton?: boolean;
    resolve: {
        settings: IPopupSettings;
    };
    private modalInstance: ng.ui.bootstrap.IModalServiceInstance = <any>this;

    constructor(private $sce: ng.ISCEService) { }

    $onInit() {
        let settings = this.resolve.settings;
        this.title = settings.title;
        this.body = this.$sce.trustAsHtml(settings.content);
        this.okTxt = settings.okTxt || 'OK';
        this.okClass = 'btn ' + (settings.okClass || 'btn-primary');
        this.closeButton = settings.closeButton !== undefined ? settings.closeButton : true;
    }

    ok() {
        this.modalInstance.close({ $value: 'closed' });
    }

    cancel() {
        this.modalInstance.dismiss({ $value: new PopupServiceCancel('cancel') });
    }
}

angular.module('app.common')
    .component('alertPopup', {
        template: require('./alertPopup.html'),
        controller: AlertPopupModalInstance,
        controllerAs: 'vm',
        bindings: {
            resolve: '=',
            close: '&',
            dismiss: '&'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/alertPopup/alertPopup.component.ts